import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PermissionsProvider } from "../../permissions";
import {
  buildLoginUrl,
  consumeRedirectLogoutFlag,
  getTokenEmail,
  isAuthenticated,
  needsPasswordChange,
} from "./authUtils";
import { useAuthBootstrap } from "./useAuthBootstrap";

/**
 * Protects authenticated app routes. Redirects guests to login with a return URL.
 * Permissions are loaded once for the authenticated session tree.
 */
export default function PrivateRoute() {
  useAuthBootstrap();
  const location = useLocation();

  // Keep provider mounted during logout redirect so Layout/MobileDrawer
  // do not crash while the tree is still rendering private shells.
  if (consumeRedirectLogoutFlag() || isAuthenticated()) {
    if (needsPasswordChange()) {
      const email = getTokenEmail();
      if (email) {
        localStorage.setItem("forgotEmail", email);
      }
      return <Navigate to="/change-password" replace />;
    }
    return (
      <PermissionsProvider>
        <Outlet />
      </PermissionsProvider>
    );
  }

  return (
    <Navigate
      to={buildLoginUrl(location.pathname, location.search)}
      replace
    />
  );
}
